import React from 'react';
import ProductCard from './ProductCard';
import {
    Grid,
    Typography,
    makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(1),
    },
    empty: {
        padding: '32px 0 40px',
        color: theme.palette.text.secondary,
    },
}));

const ProductGrid = ({ data, productSelectedCallback, emptyMessage = 'Nenhum produto encontrado' }) => {
    const classes = useStyles();

    if (!data || data.length === 0) {
        return (
            <Typography className={classes.empty} align="center">
                {emptyMessage}
            </Typography>
        );
    }

    return (
        <Grid container spacing={2} className={classes.root}>
            {data.map(product => (
                <ProductCard
                    key={product.id}
                    product={product}
                    productSelectedCallback={productSelectedCallback}
                />
            ))}
        </Grid>
    );
};

export default ProductGrid;
